import * as React from "react";
const SvgAsset21SoakIcons = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 2"
    className="icons"
    viewBox="0 0 128 128"
    {...props}
  >
    <g data-name="Layer 1">
      <path
        d="M64 119.277c31.48 0 57-24.748 57-55.276S95.48 8.723 64 8.723 7 33.472 7 64.001c0 30.528 25.52 55.276 57 55.276"
        style={{
          strokeWidth: 0,
          fill: "#1a1a1a",
        }}
      />
      <path
        d="M54.039 94.13 83.833 64 54.04 33.87"
        style={{
          fill: "none",
          stroke: "#e9eaeb",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 6,
        }}
      />
      <path
        d="M0 0h128v128H0z"
        style={{
          strokeWidth: 0,
          fill: "none",
        }}
      />
    </g>
  </svg>
);
export default SvgAsset21SoakIcons;
